import { render, staticRenderFns } from "./BorrowableAssetDetail.vue?vue&type=template&id=a6825d7a&scoped=true&"
import script from "./BorrowableAssetDetail.vue?vue&type=script&lang=js&"
export * from "./BorrowableAssetDetail.vue?vue&type=script&lang=js&"
import style0 from "./BorrowableAssetDetail.vue?vue&type=style&index=0&id=a6825d7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6825d7a",
  null
  
)

export default component.exports